define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full"
], function(csiAccess,access,full) {

	var quoteSupplierAdminRoles = ['Quote Supplier Admin'];

	var sourcingLibAdminRoles = ['Sourcing Library Administrator'];
	var sourcingAdminRoles = ['Sourcing Admin'];
	var sourcingEditRoles = sourcingAdminRoles.concat(['Sourcing Editor']);

	var sourcingOfflineAdmin = ['Sourcing Offline Administrator'];

	var styleAdminRoles = ['Style Administrator'];

	var supplierAdminRoles = ['Supplier Administrator'];
	var supplierEditRoles = supplierAdminRoles.concat(['Supplier Editor']);

	var supplierRequestAdminRoles = ['Supplier Request Administrator'];
	var supplierRequestEditRoles = supplierRequestAdminRoles.concat(['Supplier Request Editor']);
	var supplierRequestViewer = ['Supplier Request Viewer'];

	var supplierRequestMasterAdminRoles = ['Supplier Request Master Administrator'];

	var tdsBOMCreatorRoles = ['TDS - BOM Creator','TDS - BOM Administrator'];

	var tdsStyleReviewRoles = ['TDS - Style Review Creator','TDS - Style Review Administrator'];

	const sizeCurveAdminRoles = sourcingLibAdminRoles.concat(['Product Specification Library Administrator']);

	var prodSpecAdminRole = ['Product Specification Administrator '];

	csiAccess.addViewRoles({
		"SourcingViews":{
			"DutyRates":{
				"NewDutyRate":access(full(sourcingLibAdminRoles)),
				"Copy":access(full(sourcingLibAdminRoles))
			},
			"ShippingContainers":{
				"NewShippingContainer":access(full(sourcingLibAdminRoles)),
				"Copy":access(full(sourcingLibAdminRoles))
			},
			"ShippingRates":{
				"NewShippingRate":access(full(sourcingLibAdminRoles)),
				"Copy":access(full(sourcingLibAdminRoles))
			}
		},
		"LibSourcing":{
			"Factories":{
				"NewFactory":access(full(supplierAdminRoles))
			}
		},
		"Material":{
			"SupplierRequests":{
				"NewSupplierRequest":access(full(supplierRequestAdminRoles))
			}
		},
		"MaterialSecurityGroup":{
			"SupplierItems":{
				"CreateCostScenario":access(full(sourcingEditRoles), full(quoteSupplierAdminRoles)),
				"ExportOfflineCosting":access(full(sourcingOfflineAdmin)),
				"SetAsMaterialDefaultQuote":access(full(sourcingAdminRoles)),
				"PasteOfflineCosting":access(full(sourcingOfflineAdmin)),
				"QuotesCancelOffline":access(full(sourcingOfflineAdmin)),
				"UpdateCostScenarioCosts":access(full(sourcingEditRoles))
			},
			"SupplierRequests":{
				"NewSupplierRequest":access(full(supplierRequestAdminRoles)),
				"NewAllocatedSupplierRequests":access(full(supplierRequestMasterAdminRoles))
			}
		},
		"MaterialSourcing":{
			"ProductSources":{
				"EnableColorMaterialAllocation":access(full(sourcingEditRoles)),
				"ManageColorMaterialAllocation":access(full(sourcingEditRoles))
			},
			"QuoteProperties":{
				"FreezeDefaultQuote":access(full(sourcingAdminRoles))
			},
			"SupplierItems":{
				"Copy":access(full(sourcingEditRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles)),
				"CreateCostScenario":access(full(sourcingEditRoles), full(quoteSupplierAdminRoles)),
				"ExportOfflineCosting":access(full(sourcingOfflineAdmin)),
				"PasteOfflineCosting":access(full(sourcingOfflineAdmin)),
				"QuotesCancelOffline":access(full(sourcingOfflineAdmin)),
				"UpdateCostScenarioCosts":access(full(sourcingEditRoles))
			}
		},
		"Product":{
			"SupplierRequests":{
				"NewSupplierRequest":access(full(supplierRequestAdminRoles)),
				"NewAllocatedSupplierRequests":access(full(supplierRequestMasterAdminRoles))
			}
		},
		"ProductSource":{
			"SupplierItems":{
				"CreateCostScenario":access(full(sourcingEditRoles), full(quoteSupplierAdminRoles)),
				"ExportOfflineCosting":access(full(sourcingOfflineAdmin)),
				"PasteOfflineCosting":access(full(sourcingOfflineAdmin)),
				"QuotesCancelOffline":access(full(sourcingOfflineAdmin)),
				"UpdateCostScenarioCosts":access(full(sourcingEditRoles))
			},
			"StyleSamples":{
				"NewApparelBOM":access(full(tdsStyleReviewRoles)),
				"NewReviewStyle":access(full(tdsBOMCreatorRoles)),
				"NewStyle":access(full(styleAdminRoles))
			}
		},
		"SiteLibSupplierItem":{
			"SupplierItemTemplates":{
				"NewProductSource":access(full(sourcingAdminRoles), full(supplierAdminRoles)),
				"Copy":access(full(sourcingLibAdminRoles), full(sourcingAdminRoles), full(supplierAdminRoles))
			}
		},
		"StructureItem":{
			"SupplierItems":{
				"CreateCostScenario":access(full(sourcingEditRoles), full(quoteSupplierAdminRoles)),
				"ExportOfflineCosting":access(full(sourcingOfflineAdmin)),
				"SetAsStyleProductionQuote":access(full(sourcingAdminRoles)),
				"PasteOfflineCosting":access(full(sourcingOfflineAdmin)),
				"QuotesCancelOffline":access(full(sourcingOfflineAdmin)),
				"UpdateCostScenarioCosts":access(full(sourcingEditRoles))
			},
			"SupplierRequests":{
				"DeleteSupplierRequest":access(full(supplierRequestAdminRoles)),
				"ExportOfflineCosting":access(full(sourcingOfflineAdmin)),
				"NewSupplierRequest":access(full(supplierRequestAdminRoles))
			}
		},
		"StyleSourcing":{
			"ProductSources":{
				"EnableColorwayAllocation":access(full(sourcingEditRoles)),
				"ManageColorwayAllocation":access(full(sourcingEditRoles)),
				"CreateSharedDataSheetsforAgents": access(full(tdsBOMCreatorRoles),full(prodSpecAdminRole))
			},
			"QuoteProperties":{
				"FreezeProductionQuote":access(full(sourcingAdminRoles))
			},
			"SupplierItems":{
				"NewQuote":access(full(sourcingEditRoles)),
				"NewSupplierItemsFromSuppliers":access(full(sourcingEditRoles)),
				"Copy":access(full(sourcingEditRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles)),
				"CreateCostScenario":access(full(sourcingEditRoles), full(quoteSupplierAdminRoles)),
				"ExportOfflineCosting":access(full(sourcingOfflineAdmin)),
				"PasteOfflineCosting":access(full(sourcingOfflineAdmin)),
				"QuotesCancelOffline":access(full(sourcingOfflineAdmin)),
				"UpdateCostScenarioCosts":access(full(sourcingEditRoles))
			}
		},
		"SupplierRequest":{
			"MaterialLineItems":{
				"MassResetFromDataPackageTemplate":access(full(supplierRequestAdminRoles)),
				"ResetFromTemplate":access(full(supplierRequestAdminRoles))
			},
			"MaterialQuotes":{
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"NewQuote":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles))
			},
			"MaterialSamples":{
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"NewMaterialBOM":access(full(tdsBOMCreatorRoles)),
				"NewMaterialSample":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles))
			},
			"Quotes":{
				"CreateCostScenario":access(full(sourcingEditRoles), full(quoteSupplierAdminRoles)),
				"NewQuote":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"ExportOfflineCosting":access(full(sourcingOfflineAdmin)),
				"PasteOfflineCosting":access(full(sourcingOfflineAdmin)),
				"QuotesCancelOffline":access(full(sourcingOfflineAdmin)),
				"UpdateCostScenarioCosts":access(full(sourcingEditRoles)),
				"MassAdoptSupplierItemsAsStyles":access(full(sourcingEditRoles))
			},
			"StyleLineItems":{
				"MassResetFromDataPackageTemplate":access(full(supplierRequestAdminRoles)),
				"ResetFromTemplate":access(full(supplierRequestAdminRoles))
			},
			"StyleQuotes":{
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"NewQuote":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"CreateCostScenario":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles))
			},
			"StyleSamples":{
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"NewApparelBOM":access(full(tdsBOMCreatorRoles)),
				"NewStyle":access(full(styleAdminRoles)),
				"NewStyleSample":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles))
			},
			"StateHeader":{
				"CloseRequest":access(full(supplierRequestEditRoles)),
				"IssueRequest":access(full(supplierRequestEditRoles)),
				"ReIssueRequest":access(full(supplierRequestEditRoles))
			},
			"SupplierUserQuotes":{
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestViewer))
			},
			"SupplierUserMaterialSamples":{
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"NewMaterialBOM":access(full(tdsBOMCreatorRoles))
			},
			"SupplierUserStyleSamples":{
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"NewApparelBOM":access(full(tdsBOMCreatorRoles))
			}
		},
		"SupplierRequestMaster":{
			"SRSamples":{
				"NewStyle":access(full(styleAdminRoles)),
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles))
			},
			"SRMSupplierRequests":{
				"NewAllocatedSupplierRequests":access(full(supplierRequestMasterAdminRoles))
			},
			"SRSupplierQuotes":{
				"Copy":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles)),
				"CreateCostScenario":access(full(sourcingAdminRoles), full(supplierEditRoles), full(quoteSupplierAdminRoles), full(supplierRequestEditRoles))
			},
		},
		"_CS_ApparelViews":{
			"StyleSupplierRequests": {
				"Copy":access(full(supplierRequestEditRoles)),
				"Delete":access(full(supplierRequestEditRoles)),
				"NewSupplierRequest":access(full(supplierRequestAdminRoles))
			},
			"MaterialQuotes": {
				"ExportOfflineCosting":access(full(sourcingOfflineAdmin)),
				"PasteOfflineCosting":access(full(sourcingOfflineAdmin)),
				"QuotesCancelOffline":access(full(sourcingOfflineAdmin)),
				"UpdateCostScenarioCosts":access(full(sourcingEditRoles))
			},
			"MaterialSupplierRequests": {
				"Copy":access(full(supplierRequestEditRoles)),
				"Delete":access(full(supplierRequestEditRoles)),
				"NewSupplierRequest":access(full(supplierRequestAdminRoles)),
				"NewAllocatedSupplierRequests":access(full(supplierRequestMasterAdminRoles))
			},
			"SizeCurves":{
				"ApproveSizeCurve": access(full(sizeCurveAdminRoles)),
				"Copy":access(full(sizeCurveAdminRoles)),
				"Delete":access(full(sizeCurveAdminRoles)),
				"NewSizeCurve":access(full(sizeCurveAdminRoles))
			},
			"SupplierItems":{
				"CreateCostScenario":access(full(sourcingEditRoles), full(quoteSupplierAdminRoles))
			},
			"AllInspirationQuotes":{
				"CreateCostScenario":access(full(sourcingEditRoles), full(quoteSupplierAdminRoles))
			}
		}
	});
});